import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import { OrderOptimizerRailyDetailsItemStatus } from "./types/order-optimizer-raily-details-item";
import OrderOptimizerRailyDetailsItemStatusSelectOption from "./types/order-optimizer-raily-details-item-status-select-option";

const getStatusTranslation = (
  status: OrderOptimizerRailyDetailsItemStatus,
): string => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyDetailsTranslations().status;

  switch (status) {
    case OrderOptimizerRailyDetailsItemStatus.INTERESTING:
      return translations.interesting;
    case OrderOptimizerRailyDetailsItemStatus.PENDING:
      return translations.pending;
    case OrderOptimizerRailyDetailsItemStatus.REJECTED:
      return translations.rejected;
  }
};

const createSelectOption = (
  status: OrderOptimizerRailyDetailsItemStatus,
): OrderOptimizerRailyDetailsItemStatusSelectOption => {
  return {
    label: getStatusTranslation(status),
    value: status,
  };
};

const getSelectOptions = () => {
  return Object.values(OrderOptimizerRailyDetailsItemStatus).map(
    createSelectOption,
  );
};

const orderOptimizerRailyDetailsItemStatusSelectOptionFactory = {
  createSelectOption,
  getSelectOptions,
};

export default orderOptimizerRailyDetailsItemStatusSelectOptionFactory;
